//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPhoneCode as _getPhoneCode, phoneLogin as _phoneLogin } from '@/api';
import { setLocal } from '@/util';
export default {
  data: function data() {
    return {
      form: {
        phone: '',
        code: ''
      },
      counting: false,
      countDown: 120
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCountDown();
  },
  methods: {
    getPhoneCode: function getPhoneCode() {
      var _this = this;

      if (!this.verifyNumber(this.form.phone, 11)) {
        this.$message.error('手机号码格式错误');
        return;
      }

      _getPhoneCode(this.form.phone).then(function (res) {
        if (res.data.resCode === 200) {
          _this.startCountDown();

          _this.$message.success('发送成功');
        }
      });
    },
    verifyNumber: function verifyNumber(input, len) {
      return !isNaN(input) && input.length === len;
    },
    startCountDown: function startCountDown() {
      var _this2 = this;

      this.clearCountDown();
      this.counting = true;
      this.countDown = 120;
      this.countInt = setInterval(function () {
        _this2.countDown -= 1;

        if (_this2.countDown === 0) {
          clearInterval(_this2.countInt);
          _this2.counting = false;
        }
      }, 1000);
    },
    clearCountDown: function clearCountDown() {
      if (this.countInt) {
        clearInterval(this.countInt);
        this.countInt = null;
      }
    },
    phoneLogin: function phoneLogin() {
      var _this3 = this;

      if (!this.verifyNumber(this.form.phone, 11)) {
        this.$message.error('手机号码格式错误');
        return;
      } // if (!this.verifyNumber(this.form.code, 6)) {
      //   this.$message.error('验证码格式错误')
      //   return
      // }


      _phoneLogin(this.form).then(function (res) {
        if (res.data.resCode === 200) {
          setLocal('tmly_username', _this3.form.phone);

          _this3.$store.commit('setUsername', _this3.form.phone);

          var to = _this3.$route.params.from || 'ticket';
          console.log(to);

          _this3.$store.dispatch('getCartItems');

          _this3.$router.push({
            name: to
          });
        } else if (res.data.resCode === 403) {
          _this3.$message.error('账号或密码错误');
        } else {
          _this3.$message.error('网络问题');
        }
      });
    }
  }
};